module.exports = __webpack_public_path__ + "static/media/rugby.eaf96c3e.jpg";